import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Regional} from "../interface/regional";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {LoginLock} from "../interface/login-lock";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LoginLockService {
  private readonly loginLockListSubject: ReplaySubject<CountedAndPaginated<LoginLock>>
    = new ReplaySubject<CountedAndPaginated<LoginLock>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/login-lock?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<Regional>) => {
        this.loginLockListSubject.next(result);
      });
  }

  public getLoginLockListSubject(): ReplaySubject<CountedAndPaginated<LoginLock>> {
    return this.loginLockListSubject;
  }

  public sendForm(formData: object, loginLockId?: string): Observable<any> {
    if (loginLockId) {
      return this.httpClient.put(`/rest/crm/login-lock/${loginLockId}`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.httpClient.post('/rest/crm/login-lock', formData)
        .pipe(
          take(1)
        );
    }
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/login-lock/${uuid}`)
      .pipe(first());
  }

  public stop(uuid: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/login-lock/${uuid}/stop`, {})
      .pipe(first());
  }

}
